import React from 'react';

import styles from './index.module.scss';

import { Translation } from '../../components/common';

export default class CalculatorAwait extends React.Component {
  render() {
    return (
      <div className={styles['calculator-await__wrapper']}>
        <Translation className={styles['calculator-await__content']}>
          CALCULATOR_AWAIT_CONFIRMATION
        </Translation>
      </div>
    );
  }
}
